//#region Old Code

// import React from 'react';
// import SortTable from '../SortTable';
// import ListResults from '../ListResults';
// import shallowequal from 'shallowequal';
// import Icon from '../Icon';
// import { Link } from 'react-router';
// import svgEdit from '../../svgs/edit.svg';
// import filter from "../../filter";
// import { executeQuery } from "../../requests/executeQuery";
// import { TENANTS_LIST, TENANTS_LIST_COUNT } from '../../consts/queries';
// import LinkComp from "../LinkComp";
// import plus from "../../svgs/plus-white.svg";

// const limit = 50;

// export default class TenantList extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             items: null,
//             totalCount: null,
//             error: null,
//             isBusy: null,
//         };
//     }

//     componentDidMount() {
//         this.fetch(this.props.location.query);
//     }

//     fetch(q) {
//         this.setState({ isBusy: true });

//         const query = { ...q };
//         const options = filter(query, 'tenants');
//         options.param.limit = limit;
//         options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;

//         Promise.all([
//             executeQuery({ queryName: TENANTS_LIST, options: options }),
//             executeQuery({ queryName: TENANTS_LIST_COUNT, options: options })
//         ]).then(res => {
//             this.setState({
//                 items: res[0].data,
//                 totalCount: res[1].success && res[1].data[0] ? Number(res[1].data[0].TOTAL_COUNT) : false,
//                 error: res[0].success ? null : res[0].message,
//                 isBusy: null,
//             });
//         });
//     }

//     componentDidUpdate(prevProps) {
//         if (!shallowequal(prevProps.location.query, this.props.location.query)) {
//             this.fetch(this.props.location.query);
//         }
//     }

//     render() {
//         const query = this.props.location.query;

//         const columns = [
//             {
//                 name: 'View',
//                 textAlign: 'center',
//                 columnStyle: { width: 70 },
//                 render: (el) => (
//                     <Link to={{ pathname: `${arc.path.base}tenant/${el.ARCIMEDES_ROW_ID}` }}><Icon svg={svgEdit} /></Link>
//                 ),
//             },
//             {
//                 code: 'NAME',
//                 name: 'Tenant',
//                 render: (el) => el.NAME,
//             },
//         ];

//         return (
//             <div className='TenantList' data-is-busy={this.state.isBusy}>
//                 <div className='page-rounded-corner-container'>
//                     <div className='page-header-container list'>
//                         <div className='page-header list'>
//                             <div className='page-title'>Tenants</div>
//                             <LinkComp to={`${arc.path.base}tenant`}>
//                                 <div className="button-new plus positive">
//                                     <Icon svg={plus} />
//                                 </div>
//                             </LinkComp>
//                         </div>
//                         <div className='line' />
//                     </div>
//                 </div>
//                 <div className='page-body-container'>
//                     <SortTable columns={columns}
//                         items={this.state.items}
//                         query={query}
//                     />
//                     <ListResults query={this.props.location.query}
//                         pathname={this.props.location.pathname}
//                         error={this.state.error}
//                         totalCount={this.state.totalCount}
//                         itemCount={this.state.items ? this.state.items.length : false}
//                         limit={limit}
//                     />
//                 </div>
//             </div>
//         );
//     }
// }



//#endregion



import React from 'react';
import SortTable from '../SortTable';
import ListResults from '../ListResults';
import shallowequal from 'shallowequal';
import Icon from '../Icon';
import { Link } from 'react-router';
import svgEdit from '../../svgs/edit.svg';
import filter from "../../filter";
import { executeQuery } from "../../requests/executeQuery";
import { TENANTS_LIST, TENANTS_LIST_COUNT } from '../../consts/queries';
import LinkComp from "../LinkComp";
import plus from "../../svgs/plus-white.svg";
import { ApolloConsumer } from '@apollo/client';
import { GET_TENANTS, GET_TENANTS_WITH_FILTERS } from '../Graphql/Queries/TenantQuery';
import {GET_CONTACT_LIST_QUERY, GET_CONTACT_TENANTS_LIST_QUERY} from "../Graphql/ContactsQueries/contactsQuery"
import { fetchData } from '../Service/graphQlService';
const limit = 50;

export default class TenantList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: null,
            totalCount: null,
            error: null,
            isBusy: null,
        };
        this.client = null
    }

    componentDidMount() {
        if (this.client) {
            this.fetch(this.props.location.query);
        }
    }

    parseSortOptions(orderQuery) {
        if (orderQuery && Array.isArray(orderQuery)) {
            return orderQuery.map((item, index) => {
                const [field, order] = item.split('.');
                return {
                    field: field.toLowerCase(),
                    order: order.toLowerCase()
                };
            });
        }
        else if (orderQuery) {
            const [field, order] = orderQuery.split('.');
            return [{
                field: field.toLowerCase(),
                order: order.toLowerCase()
            }];
        }
        else{
            return [];
        }

    }

    parseFilterOptions(query){
        const filterObject = {};
        if(query){
            for(const key in query){
                if(key !== 'order' && key !=='page'){
                    filterObject[key]= query[key]
                }
            }
        }
        return [filterObject]
    }

    fetch(q) {
        this.setState({ isBusy: true });

        const query = { ...q };
        const options = filter(query, 'tenants');
        options.param.limit = limit;
        options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;

        var pageParams = {
            page: query.page ? Number(query.page) : 1,
            pageSize: limit
        }
        const token = localStorage.getItem('authToken');
        // Promise.all([
        //     executeQuery({ queryName: TENANTS_LIST, options: options }),
        //     executeQuery({ queryName: TENANTS_LIST_COUNT, options: options })
        // ]).then(res => {
        //     this.setState({
        //         items: res[0].data,
        //         totalCount: res[1].success && res[1].data[0] ? Number(res[1].data[0].TOTAL_COUNT) : false,
        //         error: res[0].success ? null : res[0].message,
        //         isBusy: null,
        //     });
        // });
        const sortOptions = this.parseSortOptions(q.order);
        const filterOptions = this.parseFilterOptions(q); 
        if (this.client) {
            // this.client.query({ query: GET_TENANTS_WITH_FILTERS, variables: {pageOptions: pageParams, filters:filterOptions, sortOptions: sortOptions },fetchPolicy: "no-cache", 
            // context: {
            //     headers: {
            //         authorization: `Bearer ${token}`, // Bearer token added here
            //     },
            // }})
            // fetchData(GET_TENANTS_WITH_FILTERS, {pageOptions: pageParams, filters:filterOptions, sortOptions: sortOptions })
            // .then(res => {
            //     this.setState({
            //         items: res.data.getTenents.tenents,
            //         totalCount: res.data.getTenents.totalCount,
            //         error: null,
            //         isBusy: null,
            //     });
            // })
            fetchData(GET_CONTACT_TENANTS_LIST_QUERY, {type:"Tenant",pageOptions: pageParams, filters:filterOptions, sortOptions: sortOptions })
                .then(res => {
                    this.setState({
                        items: res.data.getContacts.data,
                        totalCount: res.data.getContacts.totalCount,
                        error: null,
                        isBusy: null,
                    });
                })
                .catch(err => {
                    this.setState({
                        error: err.message, 
                        isBusy: null,
                    });
                });
        }
    }
    

    componentDidUpdate(prevProps) {
        if (!shallowequal(prevProps.location.query, this.props.location.query)) {
            this.fetch(this.props.location.query);
        }
    }

    render() {
        const query = this.props.location.query;

        const columns = [
            {
                name: 'View',
                textAlign: 'center',
                columnStyle: { width: 70 },
                // render: (el) => (
                //     // <Link to={{ pathname: `${arc.path.base}tenant/${el.arcimedes_row_id}` }}><Icon svg={svgEdit} /></Link>
                //     <Link to={{ pathname: `${arc.path.base}tenant/${el.contact_id}` }}><Icon svg={svgEdit} /></Link>
                // ),
                render: (el) => {
					const basePath = arc.path.base.endsWith('/') ? arc.path.base.slice(0, -1) : arc.path.base;
					const currentSearch = window.location.search;
					const currentPath = window.location.pathname + currentSearch;
				  
					return (
					  <Link to={{
						pathname: `${basePath}/tenant/${el.contact_id}`,
						state: { fromListUrl: currentPath }
					  }}>
						<Icon svg={svgEdit} />
					  </Link>
					);
				  }
            },
            // {
            //     code: 'NAME',
            //     name: 'Tenant',
            //     render: (el) => el.name,
            // },
            {
                code: 'FIRST_NAME',
                name: 'First Name',
                render: (el) => el.first_name,
            },
            {
                code: 'LAST_NAME',
                name: 'Last Name',
                render: (el) => el.last_name,
            },
            {
				code: 'ADDRESS',
				name: 'Address',
				render: (el) => el.address,
			},
			{
				code: 'CITY',
				name: 'City',
				render: (el) => el.city,
			},
			{
				code: 'STATE',
				name: 'State',
				render: (el) => el.state,
			},
            {
				code: 'ZIP',
				name: 'Zip',
				render: (el) => el.zip,
			}
        ];

        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client;
                    }
                    return (
                        <div className='TenantList' data-is-busy={this.state.isBusy}>
                            <div className='page-rounded-corner-container'>
                                <div className='page-header-container list'>
                                    <div className='page-header list'>
                                        <div className='page-title'>Tenants</div>
                                        {/* <LinkComp to={`${arc.path.base}tenant`}>
                                            <div className="button-new plus positive">
                                                <Icon svg={plus} />
                                            </div> */}
                                             <LinkComp
                                            to={{
                                                pathname: `${arc.path.base}tenant`,
                                                state: { fromListUrl: window.location.pathname + window.location.search }
                                            }}
                                        >
                                            <div className="button-new plus positive">
                                                <Icon svg={plus} />
                                            </div>
                                        </LinkComp>
                                    </div>
                                    <div className='line' />
                                </div>
                            </div>
                            <div className='page-body-container'>
                                <SortTable columns={columns}
                                    items={this.state.items}
                                    query={query}
                                />
                                <ListResults query={this.props.location.query}
                                    pathname={this.props.location.pathname}
                                    error={this.state.error}
                                    totalCount={this.state.totalCount}
                                    itemCount={this.state.items ? this.state.items.length : false}
                                    limit={limit}
                                />
                            </div>
                        </div>
                    )
                }}
            </ApolloConsumer>
        );
    }
}
